export default __webpack_public_path__ + "static/media/logoCirculo.e202382c.svg";